import { useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

export const useAddEmployerToTeam = () => {
    const { t } = useTranslation();
    const inputRef = useRef<HTMLInputElement>(null);
    const phoneInputWrapperRef = useRef<HTMLDivElement>(null);
    const [enableTelephoneNotice, setEnableTelephoneNotice] = useState(false);
    const [enablePopup, setEnablePopup] = useState(false);

    // костыль для удаления класса, который перезаписывает стили из custom.css
    useEffect(() => {
        if (phoneInputWrapperRef.current) {
            phoneInputWrapperRef.current
                .querySelectorAll('input.form-control')
                .forEach((input) => input.classList.remove('form-control'));
        }
    }, [enableTelephoneNotice]);

    const handleTelephoneNotice = () => {
        setEnableTelephoneNotice(!enableTelephoneNotice);
    };

    const handleEnablePopup = () => {
        setEnablePopup(!enablePopup);
    };

    return {
        inputRef,
        phoneInputWrapperRef,
        t,
        handleTelephoneNotice,
        enableTelephoneNotice,
        handleEnablePopup,
        enablePopup,
    };
};
